export function getAssetRootUrl(template) {
  return template.assetRootUrl ?? template.proxy.assetRootUrl;
}

export function getPageAssetUrl(
  template,
  pageId,
  options = { prefix: '', suffix: '', useServerAssets: false, folder: '/pages' },
) {
  if (getAssetRootUrl(template)) {
    return `${getAssetRootUrl(template)}/${
      options.useServerAssets ? 'assets_server' : 'assets_client'
    }${options.folder ?? '/pages'}/${options.prefix ?? ''}${pageId}${options.suffix ?? ''}.png`;
  }
  return '';
}

export function getAssetUrl(template, name) {
  if (getAssetRootUrl(template)) {
    return `${getAssetRootUrl(template)}${name}`;
  }
  return '';
}

export function getLayoutAssetUrl(
  template,
  pageId,
  options = { prefix: '', suffix: '', media: '' },
) {
  if (getAssetRootUrl(template)) {
    return `${getAssetRootUrl(template)}/assets_client/layouts/${options.prefix || ''}${pageId}${
      options.suffix || ''
    }${options.media || ''}.png`;
  }
  return '';
}
